<span ng-bind="vm.person.getDisplayName()"></span>,
<span ng-if="vm.person.getGeburtsdatum()">
    <span ng-bind="vm.person.getGeburtsdatum() | amDateFormat:'D.M.YYYY'"></span>,
</span>
<i class="fa fa-mars" ng-if="vm.person.geschlecht === vm.geschlecht.MAENNLICH"></i>
<i class="fa fa-venus" ng-if="vm.person.geschlecht === vm.geschlecht.WEIBLICH"></i>
<i class="fa fa-genderless" ng-if="vm.person.geschlecht === vm.geschlecht.DIVERS"></i>
<i class="fa fa-unknown" ng-if="vm.person.geschlecht === vm.geschlecht.UNBEKANNT"></i>
